import React from 'react';
import { ROUTES } from 'App/Routes/constants';
import { HelpLink, RedirectCard } from 'commons/components';
import { useTranslationWithPrefix } from 'commons/utils';
import { PersonalDataArgentina } from './PersonalDataArgentina';

const ConfigurationArgentina = () => {
  const { t } = useTranslationWithPrefix('configuration');

  return (
    <>
      <PersonalDataArgentina />
      <RedirectCard
        title={t('section.paymentMethods')}
        path={ROUTES.PAYMENT_METHODS}
      />
      <RedirectCard
        title={t('section.settlementPeriod')}
        path={ROUTES.SETTLEMENT_PERIOD}
      />
      <RedirectCard
        title={t('section.installments')}
        path={ROUTES.INSTALLMENTS}
      />
      <HelpLink text={t('helpLink.text')} href={t('helpLink.href')} />
    </>
  );
};

export default ConfigurationArgentina;
